import React from 'react';
import Heading from '@legacy-vfuk/core-heading';
import {
  CollapsibleContainer,
  CollapsibleContainerBody,
  CollapsibleContainerHeader,
} from '@legacy-vfuk/core-collapsible-container';
import SimpleGrid from '@legacy-vfuk/core-simple-grid';
import { renderRichText } from '@vhub/gatsby-source-contentful/rich-text';
import options from '../../../../helpers/ContentFulOptions';
import Block from '@legacy-vfuk/core-block';
import Accordion from '@legacy-vfuk/core-accordion';
import useAccordion from '@legacy-vfuk/core-accordion/dist/hooks/useAccordion';
import {
  AccordionWrapper,
  BlockWrapper,
  CtaButtonRowWrapper,
  HeadingWrapper,
} from './styles/SectionAccordion.styles';
import { SectionAccordionProps } from './types/SectionAccordion.types';
import CtaButtonRow from '../../Elements/CtaButtons/CtaButtonRow';
import fireButtonAndLinkClicksEvent from '../../../../helpers/fireButtonAndLinkClicksEvent';

const SectionAccordion = ({ section }: SectionAccordionProps) => {
  const { name, title, content, invertColourScheme, buttonRow } = section;
  const { openIds, onToggle } = useAccordion({
    multi: true,
  });

  return (
    <BlockWrapper id={name}>
      <Block appearance={invertColourScheme ? 'alt2' : 'primary'}>
        <SimpleGrid
          columns={{
            sm: 1,
          }}
        >
          <div data-testid="accordion-header">
            <HeadingWrapper>
              <Heading text={title ? title : name} level={3} justify="center" />
            </HeadingWrapper>
          </div>
        </SimpleGrid>
        <SimpleGrid
          columns={{
            sm: 1,
          }}
        >
          <AccordionWrapper>
            <Accordion
              appearance={invertColourScheme ? 'primary' : 'secondary'}
              openIds={openIds}
              onToggle={onToggle}
            >
              {content?.map(item => {
                const { id, heading, accordionContent } = item;
                const accordionText = renderRichText(accordionContent, options);
                return (
                  <CollapsibleContainer key={id} id={id}>
                    <div
                      className="accordion-collapsible-container-test-class"
                      aria-expanded={openIds.includes(id)}
                    >
                      {openIds.includes(id) && fireButtonAndLinkClicksEvent({
                          event_label: heading,
                          event_action: 'accordion click',
                        })}
                      <CollapsibleContainerHeader>
                        {heading}
                      </CollapsibleContainerHeader>
                      <CollapsibleContainerBody>
                        {accordionText}
                      </CollapsibleContainerBody>
                    </div>
                  </CollapsibleContainer>
                );
              })}
            </Accordion>
          </AccordionWrapper>
        </SimpleGrid>
        {buttonRow && (
          <CtaButtonRowWrapper>
            <CtaButtonRow
              buttonRowAlignment={buttonRow.buttonRowAlignment}
              buttons={buttonRow.buttons}
            />
          </CtaButtonRowWrapper>
        )}
      </Block>
    </BlockWrapper>
  );
};

export default SectionAccordion;
